/* Shop the look, desktop (769px and up). See assets/look-desktop.css.
 *
 * Focus: on every scroll the frame nearest the middle of the rail gets
 * --f 1 and `data-focus`; its neighbours get a smaller --f by distance, and
 * the stylesheet turns that into scale, blur and fade. When the scroll
 * settles, the rail glides so the nearest frame sits exactly in the middle.
 * Arrows step one frame. The progress line under the rail is the scroll
 * position.
 *
 * In this look: a click on the focused model, or on any dot, opens the panel
 * on the right with one row per piece in that frame. The rows are the same
 * card nodes the phone sheet borrows (snippets/look-card.liquid), moved in
 * and moved back, never copied, so prices currency.js has rewritten stay
 * rewritten. Inside the panel a size pill PICKS a size instead of adding
 * (the document-level handler in assets/card-carousel.js is stopped in the
 * capture phase); the row's + adds that piece, and Add full look adds every
 * picked piece through VolatileCart.add, the PDP's own path.
 */
(function () {
  var desk = window.matchMedia('(min-width: 769px)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  var boot = function (root) {
    if (root.hasAttribute('data-look-desk')) return;
    var track = root.querySelector('[data-looks-track]');
    var store = root.querySelector('[data-looks-cards]');
    var side = root.querySelector('[data-looks-side]');
    var list = root.querySelector('[data-looks-side-list]');
    var foot = root.querySelector('[data-looks-foot]');
    if (!track || !store || !side || !list) return;
    root.setAttribute('data-look-desk', '');
    var thumb = root.querySelector('[data-looks-thumb]');
    var count = root.querySelector('[data-looks-count]');
    var sideN = root.querySelector('[data-looks-side-n]');
    var sideTotal = root.querySelector('[data-looks-side-total]');
    var sideAdd = root.querySelector('[data-looks-side-add]');
    var prev = root.querySelector('[data-looks-prev]');
    var next = root.querySelector('[data-looks-next]');

    var frames = function () { return Array.prototype.slice.call(track.querySelectorAll('.v-looks__look')); };
    var focused = null;

    /* ── focus by distance from the middle ── */
    var pitch = function () {
      var f = frames();
      return f.length > 1 ? f[1].offsetLeft - f[0].offsetLeft : track.clientWidth / 4.5;
    };
    var centerOf = function (el) { return el.offsetLeft + el.offsetWidth / 2; };
    /* The focus point sits left of centre by --looks-shift (half the glass
       panel's footprint), so the model in focus is clear of the panel. */
    var shift = function () { return parseFloat(getComputedStyle(root).getPropertyValue('--looks-shift')) || 0; };
    var mid = function () { return track.scrollLeft + track.clientWidth / 2 - shift(); };
    var paint = function () {
      var m = mid();
      var p = pitch() || 1;
      var best = null, bestD = Infinity;
      /* Nearest frame first, so only IT can be sharp. */
      frames().forEach(function (el) { var dd = Math.abs(centerOf(el) - m); if (dd < bestD) { bestD = dd; best = el; } });
      bestD = Infinity;
      var best0 = best || focused || frames()[0];
      /* The oval (Aditya, 2026-10-28): the models stand on a ring seen from
         a little above. Each frame's angle on the ring comes from its scroll
         distance (one frame = one step of 180/7 degrees, so seven models span
         the front half). Position on screen is sin/cos of that angle: sides
         fold inward and rise, the back half is hidden. The flex row only
         drives the scroll; the translate cancels its spacing. */
      var STEP = Math.PI / 7;
      var rx = track.clientWidth * 0.46;
      var ry = (best0 ? best0.offsetHeight : track.clientHeight) * 0.22;
      frames().forEach(function (el) {
        var sd = (centerOf(el) - m) / p;
        var d = Math.abs(sd);
        var f = Math.max(0, Math.min(1, 1 - d * 0.5));
        el.style.setProperty('--f', f.toFixed(3));
        el.style.setProperty('--d', Math.max(-3, Math.min(3, sd)).toFixed(3));
        if (d > 4.5) {
          if (!el.hasAttribute('data-hid')) { el.setAttribute('data-hid', ''); el.style.opacity = '0'; el.style.visibility = 'hidden'; el.style.transform = ''; el.style.filter = ''; }
          el.removeAttribute('data-near');
          return;
        }
        el.removeAttribute('data-hid');
        var th = Math.max(-Math.PI / 2 - 0.3, Math.min(Math.PI / 2 + 0.3, sd * STEP));
        var c = Math.cos(th);
        var vis = Math.max(0, c);
        var tx = Math.sin(th) * rx - sd * p;
        var ty = -(1 - c) * ry;
        var depth = vis * vis;
        var sc = 0.35 + 0.65 * depth;
        el.style.visibility = vis > 0.02 ? 'visible' : 'hidden';
        el.style.opacity = (0.3 + 0.7 * depth).toFixed(3);
        el.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ')';
        /* Only the model in focus is sharp; every other one carries at
           least a light blur that grows round the ring. */
        el.style.filter = el === best ? 'none' : 'blur(' + Math.max(0.8, (1 - depth) * 6).toFixed(2) + 'px)';
        el.style.zIndex = String(10 + Math.round(vis * 10));
        if (d < 3.2) el.setAttribute('data-near', ''); else el.removeAttribute('data-near');
      });
      if (best !== focused) {
        if (focused) focused.removeAttribute('data-focus');
        focused = best;
        if (focused) focused.setAttribute('data-focus', '');
        if (count && focused) {
          var i = +focused.getAttribute('data-look-i') || 1;
          var n = total();
          count.textContent = (i < 10 ? '0' + i : i) + ' / ' + (n < 10 ? '0' + n : n);
        }
        if (focused && focused !== panelFrame) fill(focused);
      }
      /* Circular rail: the line shows the model's own number, not the
         scroll position, and the arrows never switch off. */
      if (thumb && focused) {
        var n2 = total();
        var w = Math.max(0.04, Math.min(0.5, 4 / Math.max(n2, 1)));
        var fr = n2 > 1 ? ((+focused.getAttribute('data-look-i') || 1) - 1) / (n2 - 1) : 0;
        var pw = foot ? foot.querySelector('.v-looks__prog').clientWidth : track.clientWidth;
        thumb.style.setProperty('--w', w.toFixed(4));
        thumb.style.setProperty('--x', (fr * (1 - w) * pw).toFixed(1) + 'px');
      }
      if (prev) prev.removeAttribute('data-off');
      if (next) next.removeAttribute('data-off');
    };
    /* ── circular: every frame is numbered once; near either end the frames
       from the other end are moved across and the scroll position is
       corrected in the same step, so the rail never runs out. ── */
    var numbered = 0;
    var lastSelfMove = 0;
    var number = function () {
      frames().forEach(function (el) { if (!el.hasAttribute('data-look-i')) el.setAttribute('data-look-i', String(++numbered)); });
    };
    var total = function () { return numbered; };
    var wrap = function () {
      if (gliding) return false;
      var all = frames();
      if (all.length < 8) return false;
      var p = pitch();
      var m = mid();
      var idx = 0, best = Infinity;
      all.forEach(function (el, k) { var d = Math.abs(centerOf(el) - m); if (d < best) { best = d; idx = k; } });
      var moveN = 3;
      if (idx < moveN) {
        lastSelfMove = performance.now();
        var tail = all.slice(-moveN);
        tail.forEach(function (el) { track.insertBefore(el, all[0]); });
        track.scrollLeft += moveN * p;
        return true;
      }
      if (idx > all.length - 1 - moveN) {
        lastSelfMove = performance.now();
        var head = all.slice(0, moveN);
        head.forEach(function (el) { track.appendChild(el); });
        track.scrollLeft -= moveN * p;
        return true;
      }
      return false;
    };
    /* The section hands out frames 25 at a time as the rail nears its end.
       A loop never reaches an end, so pull every batch now: the section's
       own scroll handler runs synchronously on a dispatched event, and the
       position is put back before anything paints. */
    var loadAll = function () {
      var keep = track.scrollLeft;
      for (var guard = 0; guard < 12; guard++) {
        var before = track.children.length;
        track.scrollLeft = track.scrollWidth;
        track.dispatchEvent(new Event('scroll'));
        if (track.children.length === before) break;
      }
      track.scrollLeft = keep;
      number();
    };
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; wrap(); paint(); });
    };
    var settleTimer = 0;
    var glideTimer = 0;
    var gliding = false;
    /* A programmatic glide owns the scroll until it lands: settle() stays
       out of its way, so a click never fights the glide it started. */
    /* Our own eased scroll, not the browser's smooth scroll: that one takes
       half a second it will not let us shorten, which is the lag Aditya
       felt when a model was "99% there". Snap lands in 180ms, an arrow
       press in 260ms, with an ease-out so it still feels like a glide. */
    var anim = 0;
    var animateTo = function (left, ms) {
      window.cancelAnimationFrame(anim);
      var from = track.scrollLeft;
      var d = left - from;
      if (Math.abs(d) < 1 || still.matches || ms <= 0) { track.scrollLeft = left; gliding = false; return; }
      var t0 = performance.now();
      gliding = true;
      var tick = function (now) {
        var p = Math.min(1, (now - t0) / ms);
        var e = 1 - Math.pow(1 - p, 3);
        track.scrollLeft = from + d * e;
        if (p < 1) anim = requestAnimationFrame(tick);
        else { gliding = false; wrap(); paint(); }
      };
      anim = requestAnimationFrame(tick);
    };
    var glideTo = function (el, ms) {
      if (!el) return;
      var left = Math.round(centerOf(el) - track.clientWidth / 2 + shift());
      if (Math.abs(track.scrollLeft - left) < 1) return;
      animateTo(left, ms == null ? 260 : ms);
    };
    var settle = function () {
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(function () {
        if (!focused || gliding) return;
        var off = centerOf(focused) - mid();
        if (Math.abs(off) > 1) glideTo(focused, 180);
      }, 80);
    };
    /* A wheel or drag during a glide takes over: stop animating at once. */
    track.addEventListener('wheel', function () { window.cancelAnimationFrame(anim); gliding = false; }, { passive: true });
    track.addEventListener('pointerdown', function () { window.cancelAnimationFrame(anim); gliding = false; }, { passive: true });
    track.addEventListener('scroll', function () { onScroll(); settle(); }, { passive: true });
    window.addEventListener('resize', onScroll);

    /* Arrows: one frame per press. Capture phase so the section's own
       four-frame step never runs. */
    var stepOne = function (dir) {
      var all = frames();
      var i = Math.max(0, Math.min(all.length - 1, all.indexOf(focused) + dir));
      glideTo(all[i]);
    };
    [[prev, -1], [next, 1]].forEach(function (pair) {
      if (!pair[0]) return;
      pair[0].addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        stepOne(pair[1]);
      }, true);
    });

    /* A click on a model: centre it, open the panel. */
    track.addEventListener('click', function (e) {
      if (!desk.matches) return;
      var link = e.target.closest('.v-looks__photo-link');
      if (!link) return;
      var frame = link.closest('.v-looks__look');
      if (!frame) return;
      e.preventDefault();
      if (frame !== focused) glideTo(frame);
    });

    /* ── In this look ── */
    var rows = [];
    var panelFrame = null;
    var cardFor = function (h) {
      var all = store.querySelectorAll('[data-look-card]');
      for (var i = 0; i < all.length; i++) if (all[i].getAttribute('data-look-card') === h) return all[i];
      return null;
    };
    var numberDots = function (frame) {
      frame.querySelectorAll('[data-look-dot]').forEach(function (dot, i) {
        var core = dot.querySelector('.v-looks__dot-core');
        if (!core) return;
        var n = core.querySelector('.v-looks__dot-num');
        if (!n) { n = document.createElement('span'); n.className = 'v-looks__dot-num'; core.appendChild(n); }
        n.textContent = String(i + 1);
        dot.setAttribute('data-n', String(i + 1));
      });
    };
    var putBack = function () {
      rows.forEach(function (r) { if (r.card) store.appendChild(r.card); });
      rows = [];
      list.textContent = '';
    };
    var money = function () {
      /* Sum what the cards SHOW, so a rewritten currency adds up in itself. */
      var sym = '', total = 0, ok = true;
      rows.forEach(function (r) {
        var cur = r.card.querySelector('.v-price__current');
        if (!cur) { ok = false; return; }
        var s = cur.querySelector('.v-price__cur');
        var n = cur.querySelector('.v-price__num');
        if (!sym && s) sym = s.textContent.trim();
        var v = n ? parseFloat(n.textContent.replace(/[^0-9.]/g, '')) : NaN;
        if (isNaN(v)) ok = false; else total += v;
      });
      if (!ok) return '';
      return sym + ' ' + Math.round(total).toLocaleString('en-IN');
    };
    var picked = function (row) { return row.card.querySelector('.v-looks__size[data-pick]'); };
    var refreshFoot = function () {
      if (sideTotal) sideTotal.textContent = money();
      var buyable = rows.filter(function (r) { return r.card.querySelector('.v-looks__size'); });
      var ready = buyable.length > 0 && buyable.every(picked);
      if (sideAdd) {
        sideAdd.disabled = !ready;
        sideAdd.textContent = ready ? 'Add full look to bag' : 'Pick a size for every piece';
      }
      rows.forEach(function (r) { if (r.add) r.add.disabled = !picked(r); });
    };
    var fill = function (frame) {
      panelFrame = frame;
      putBack();
      var dots = frame.querySelectorAll('[data-look-dot]');
      var seen = {};
      dots.forEach(function (dot, i) {
        var h = dot.getAttribute('data-look-dot');
        if (seen[h]) return;
        seen[h] = true;
        var card = cardFor(h);
        if (!card) return;
        var row = document.createElement('div');
        row.className = 'v-looks__row';
        row.setAttribute('data-row', h);
        var n = document.createElement('span');
        n.className = 'v-looks__row-n';
        n.textContent = String(i + 1);
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'v-looks__row-add';
        add.setAttribute('aria-label', 'Add this piece to bag');
        add.textContent = '+';
        add.disabled = true;
        row.appendChild(n);
        row.appendChild(card);
        row.appendChild(add);
        list.appendChild(row);
        rows.push({ handle: h, card: card, add: add, row: row });
      });
      numberDots(frame);
      if (sideN) sideN.textContent = rows.length + (rows.length === 1 ? ' piece' : ' pieces');
      refreshFoot();
    };
    /* The panel is always open and follows the model in focus. A dot only
       highlights its row; nothing scrolls, nothing re-fills. */
    var showRow = function (frame, hot) {
      if (frame !== panelFrame) fill(frame);
      rows.forEach(function (r) { r.row.toggleAttribute('data-hot', r.handle === hot); });
      var row = list.querySelector('[data-row="' + hot + '"]');
      if (row) row.scrollIntoView({ block: 'nearest', behavior: still.matches ? 'auto' : 'smooth' });
    };

    /* Inside the panel a pill picks; the + and the big button add. Capture
       phase, so the document handler that would add on the pill never runs. */
    side.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-card-add]');
      if (!pill) return;
      e.preventDefault();
      e.stopPropagation();
      pill.parentElement.querySelectorAll('[data-card-add]').forEach(function (p) { p.removeAttribute('data-pick'); });
      pill.setAttribute('data-pick', '');
      refreshFoot();
    }, true);
    var addVariant = function (id) {
      if (window.VolatileCart && typeof window.VolatileCart.add === 'function') return window.VolatileCart.add(id, 1);
      var body = new FormData();
      body.set('id', String(id));
      body.set('quantity', '1');
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) { if (!r.ok) throw new Error('add.js ' + r.status); return r.json(); });
    };
    var openBag = function () {
      if (window.VolatileUI && typeof window.VolatileUI.openCart === 'function') window.VolatileUI.openCart();
    };
    var busy = false;
    var addRows = function (which) {
      if (busy) return;
      var ids = which.map(picked).filter(Boolean).map(function (p) { return p.getAttribute('data-card-add'); });
      if (!ids.length) return;
      busy = true;
      if (sideAdd) sideAdd.setAttribute('data-busy', '');
      var chain = Promise.resolve();
      ids.forEach(function (id) { chain = chain.then(function () { return addVariant(id); }); });
      chain.then(openBag).catch(function () {
        if (window.VolatileCart && window.VolatileCart.refresh) { try { window.VolatileCart.refresh(); } catch (_) {} }
      }).then(function () {
        busy = false;
        if (sideAdd) sideAdd.removeAttribute('data-busy');
      });
    };
    list.addEventListener('click', function (e) {
      var add = e.target.closest('.v-looks__row-add');
      if (!add) return;
      var row = rows.filter(function (r) { return r.add === add; })[0];
      if (row) addRows([row]);
    });
    if (sideAdd) sideAdd.addEventListener('click', function () { addRows(rows); });

    /* The section's own script hands desktop dot clicks here. */
    window.TzLookSide = {
      openDot: function (dot) {
        var frame = dot.closest('.v-looks__look');
        if (!frame) return;
        showRow(frame, dot.getAttribute('data-look-dot'));
      }
    };

    side.hidden = false;
    root.setAttribute('data-side-open', '');
    /* First paint: the shuffle in the section script runs at parse time,
       before this deferred file, so the frames are already in order. Start
       on the first frame, centred. */
    paint();
    /* Start on the third model so there are neighbours on both sides. The
       frames may have no width yet (images arriving), so this retries from
       the delayed paints below until it lands. */
    var started = false;
    var start = function () {
      if (started) return;
      var all = frames();
      if (!all.length || !all[0].offsetWidth) return;
      /* A product page (sections/pdp-pair.liquid) names the model to open
         on, this SKU's own frame or the partner frame it is worn in; the
         panel follows the model in focus, so it opens with that look. */
      var want = window.__tzLookFocus;
      if (typeof want === 'string') want = { product: want };
      var startAt = (want && all.filter(function (el) {
        return el.getAttribute('data-look-product') === want.product && (!want.slot || el.getAttribute('data-look-slot') === want.slot);
      })[0])
        || all.filter(function (el) { return el.getAttribute('data-look-i') === '3'; })[0] || all[Math.min(2, all.length - 1)];
      track.scrollLeft = Math.max(0, Math.round(centerOf(startAt) - track.clientWidth / 2 + shift()));
      /* Only counts once the rail actually moved: the section's own shuffle
         can swap the frames out from under an early attempt. */
      started = track.scrollLeft > 0;
      wrap();
      paint();
    };
    /* Boot waits for the track to go quiet. The section's own script
       (shuffle, then only the first 25 frames) may run before or after this
       file depending on how the lazy section landed; 350ms without a
       childList change means it is done. Then every batch is pulled, the
       frames are numbered and the start position taken. Our own ring moves
       (wrap) are flagged and never re-arm this. */
    var bootTimer = 0;
    var arm = function () {
      window.clearTimeout(bootTimer);
      bootTimer = window.setTimeout(function () {
        loadAll();
        started = false;
        start();
        paint();
      }, 350);
    };
    arm();
    new MutationObserver(function () {
      if (performance.now() - lastSelfMove < 80) { onScroll(); return; }
      arm();
      onScroll();
    }).observe(track, { childList: true });
    /* Frames may still be sizing (images arriving); paint again as they settle. */
    var again = function () { paint(); };
    window.setTimeout(again, 400);
    window.setTimeout(again, 1200);
    window.addEventListener('load', again);
    if ('ResizeObserver' in window) new ResizeObserver(onScroll).observe(track);
  };

  var start = function () {
    if (!desk.matches) return;
    document.querySelectorAll('[data-looks]').forEach(boot);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  /* The home page loads this section lazily (snippets/lazy-section). */
  new MutationObserver(function () { if (desk.matches) document.querySelectorAll('[data-looks]:not([data-look-desk])').forEach(boot); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
